import { pluralize } from 'humanize-plus'
import { PlaybooksFrequency } from 'app/modules/playbook/constants'

import './style.styl'

const AudienceLabels = Object.freeze({
  SEGMENT: 'your segment(s)',
  VISITORS: 'anonymous visitors',
  USERS: 'known users',
  EVERYONE: 'everyone',
  NONE: 'nobody',
})

const FREQUENCY_COPY = {
  ONCE: (
    <span>
      it will be shown until people <strong>open or dismiss it</strong>.
    </span>
  ),
  ONCE_PER_SESSION: (
    <span>
      it will be shown until someone opens or dismisses it. After{' '}
      <strong>30 minutes of visitor inactivity</strong>, it will be shown again.
    </span>
  ),
  ALWAYS: (
    <span>
      it will be shown <strong>every time</strong> the user visits the page.
    </span>
  ),
}

const ReviewSummary = ({ audience, playbookFrequency, numConditions }) => {
  if (!audience) {
    return (
      <div className="playbook-targeting-advanced-frequency-info">
        <p>This playbook can only be shown by activating the #DriftLink.</p>
      </div>
    )
  }
  return (
    <div className="playbook-targeting-advanced-frequency-info">
      <p>
        This playbook will be shown to <strong>{AudienceLabels[audience]}</strong>
        {numConditions !== 0 && (
          <span>
            {' '}
            who meets{' '}
            <strong>
              {numConditions} targeting {pluralize(numConditions, 'condition')}
            </strong>
          </span>
        )}, and {FREQUENCY_COPY[playbookFrequency]}
      </p>
    </div>
  )
}

const Review = ({
  isOnce,
  isSession,
  isAlways,
  handleSetFrequency,
  playbookFrequency,
  audience,
  numConditions,
}) => (
  <div className="playbook-builder-targeting-advanced-wrapper">
    <header className="playbook-title-header">
      <h2>Frequency</h2>
      <p>Need to fine tune the targeting behavior of your playbook? You can do that here.</p>
    </header>

    <div className="playbook-container playbook-targeting-advanced-toggle-summary">
      <div className="playbook-targeting-advanced-label">How often should the audience see it? </div>
      <div className="playbook-targeting-advanced-frequency-wrapper drift-form">
        <div className="playbook-targeting-advanced-frequency-options">
          <div className="playbook-targeting-advanced-frequency-option">
            <input
              type="radio"
              onClick={handleSetFrequency}
              checked={isAlways}
              id="choiceAlways"
              name="playbookFrequency"
              value={PlaybooksFrequency.ALWAYS}
            />
            <label htmlFor="choiceAlways">
              On every page load
            </label>
          </div>
          <div className="playbook-targeting-advanced-frequency-option">
            <input
              type="radio"
              checked={isSession}
              id="choiceSession"
              onClick={handleSetFrequency}
              name="playbookFrequency"
              value={PlaybooksFrequency.SESSION}
            />
            <label htmlFor="choiceSession">
              Until they interact, once per session{' '}
            </label>
          </div>
          <div className="playbook-targeting-advanced-frequency-option">
            <input
              type="radio"
              onClick={handleSetFrequency}
              checked={isOnce}
              id="choiceOnce"
              name="playbookFrequency"
              value={PlaybooksFrequency.ONCE}
            />
            <label htmlFor="choiceOnce">
              Until they interact, then hide it
            </label>
          </div>
          <hr />
          <ReviewSummary
            numConditions={numConditions}
            playbookFrequency={playbookFrequency}
            audience={audience}
          />
        </div>
      </div>
    </div>
  </div>
)

export default Review



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/TargetingAdvanced/component.js